import { useState } from 'react'
import { useAuth, userMode } from '@10000/react'
import { Box, PopUpMenu, SupportDialog } from '../widgets'

export const SuperUserMenu = ({ open, onClose, mobile }) => {
  const { logout, user } = useAuth()
  const [supportOpen, setSupportOpen] = useState(false)

  const items = [
    { text: 'Log out', onClick: logout },
    ...(user.tenantId !== 'super'
      ? [
        { text: '', onClick: () => { return null } },
        { text: 'Organisation user mode', onClick: () => userMode('tenant', '/shivoo/') }
      ]
      : []
    )
  ]

  return (
    <Box className={mobile ? 'mobile-only' : 'desktop-only'} zIndex={1000}>
      <PopUpMenu
        items={items}
        open={open}
        onClose={onClose}
        align="center"
        width={180}
      />
      <SupportDialog open={supportOpen} onClose={() => setSupportOpen(false)} />
    </Box>
  )
}
